import React from "react";
import { Box, Typography, Link, Stack, useTheme } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import { useLanguage } from "../../context/LanguageContext";

export default function Contacto({ id }) {
  const theme = useTheme();
  const { language } = useLanguage();

  const textsContacto = {
    es: {
      titulo: "¡CONTÁCTAME!",
      correo: "Correo",
    },
    en: {
      titulo: "CONTACT ME!",
      correo: "Email",
    },
  };

  const contactos = [
    {
      icono: <EmailIcon />,
      label: textsContacto[language].correo,
      valor: "dariog_36@hotmail.com",
      href: "mailto:dariog_36@hotmail.com",
    },
    {
      icono: <LinkedInIcon />,
      label: "LinkedIn",
      valor: "in/hernangomezm94",
      href: "https://www.linkedin.com/in/hernan-dario-gomez-marquez-b12958203/",
    },
    {
      icono: <WhatsAppIcon />,
      label: "Whatsapp",
      valor: "+57 - 310 86 57 315",
      href: "https://wa.me/573108657315",
    },
    {
      icono: <GitHubIcon />,
      label: "GitHub",
      valor: "/JanVal3k",
      href: "https://github.com/JanVal3k",
    },
  ];

  return (
    <Box
      id={id}
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: { xs: 3, sm: 4 },
        py: { xs: 6, sm: 8 },
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
      }}
    >
      <div data-aos="zoom-out">
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontFamily: theme.typography.fontFamily[0],
            fontWeight: 700,
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            background: theme.palette.secondary.main,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 4,
            textTransform: "uppercase",
          }}
        >
          {textsContacto[language].titulo}
        </Typography>

        <Stack spacing={3} sx={{ width: "100%", maxWidth: "600px" }}>
          {contactos.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "center",
                fontSize: "1.1rem",
                color: theme.palette.text.secondary,
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  color: theme.palette.secondary.main,
                },
              }}
            >
              <Box
                sx={{ fontSize: "1.5rem", color: theme.palette.primary.main }}
              >
                {item.icono}
              </Box>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {item.label}:
              </Typography>
              <Link
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.secondary.main,
                  "&:hover": {
                    color: theme.palette.error.main,
                  },
                }}
              >
                {item.valor}
              </Link>
            </Box>
          ))}
        </Stack>
      </div>
    </Box>
  );
}
